module.exports = __webpack_public_path__ + "static/media/image_8.6c8152ef.jpg";